import { Component, ViewEncapsulation, input } from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { EmailTextComponent } from '../email-text/email-text.component';

@Component({
  selector: 'email-button',
  styleUrls: ['./email-button.component.less'],
  hostDirectives: [SsrMarkToUnwrapDirective],
  imports: [EmailTextComponent],
  template: `
    <div [class]="getClassNames()">
      <table class="button-table" cellspacing="0" cellpadding="0">
        <tr>
          <td class="button-content">
            <a class="button-link" [href]="href().toJSON()">
              <email-text [contents]="label()" [className]="'button-anchor-text'" />
            </a>
          </td>
        </tr>
      </table>
    </div>
  `,
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class EmailButtonComponent {
  public readonly href = input<WrappedValue<string>>(undefined!);
  public readonly label = input<WrappedValue<string>>(undefined!);
  public readonly theme = input<'default' | 'primary' | 'danger' | 'accent'>('default');
  public readonly inline = input<boolean>(false);

  public getClassNames() {
    return ['button', `button-${this.theme()}`, this.inline() ? 'button-inline' : 'button-block'];
  }
}
